/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */
import type {
  Error,
  GetActivities200,
  GetActivitiesParams
} from '../model';

import { customFetch } from '../../mutator/custom-fetch';

/**
 * Retrieve a paginated list of activities for the entity. Supports filtering by resource_type, resource_id, and action. Activities are ordered by created_at descending by default.
 * @summary List activities
 */
export type getActivitiesResponse200 = {
  data: GetActivities200
  status: 200
}

export type getActivitiesResponse400 = {
  data: Error
  status: 400
}

export type getActivitiesResponse401 = {
  data: Error
  status: 401
}

export type getActivitiesResponse403 = {
  data: Error
  status: 403
}

export type getActivitiesResponse404 = {
  data: Error
  status: 404
}

export type getActivitiesResponse500 = {
  data: Error
  status: 500
}

export type getActivitiesResponseSuccess = (getActivitiesResponse200) & {
  headers: Headers;
};
export type getActivitiesResponseError = (getActivitiesResponse400 | getActivitiesResponse401 | getActivitiesResponse403 | getActivitiesResponse404 | getActivitiesResponse500) & {
  headers: Headers;
};

export type getActivitiesResponse = (getActivitiesResponseSuccess | getActivitiesResponseError)

export const getGetActivitiesUrl = (params?: GetActivitiesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/activities?${stringifiedParams}` : `/activities`
}

export const getActivities = async (params?: GetActivitiesParams, options?: RequestInit): Promise<getActivitiesResponse> => {
  
  return customFetch<getActivitiesResponse>(getGetActivitiesUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

